// extracted by mini-css-extract-plugin
export var brandLockup = "_lg-5";
export var brandLogo = "_lg-6";
export var bullet = "_lg-1i";
export var bulletText = "_lg-1h";
export var bullets = "_lg-1c";
export var callout = "_lg-12";
export var calloutBody = "_lg-14";
export var calloutLabel = "_lg-13";
export var checkIcon = "_lg-1e";
export var checkList = "_lg-1b";
export var checkSvg = "_lg-1f";
export var checkText = "_lg-1g";
export var choiceCard = "_lg-x";
export var choiceDescription = "_lg-10";
export var choiceIcon = "_lg-11";
export var choiceText = "_lg-y";
export var choiceTitle = "_lg-z";
export var closeButton = "_lg-d";
export var codeText = "_lg-28";
export var compactPage = "_lg-f";
export var content = "_lg-9";
export var contentColumn = "_lg-3";
export var coverageCard = "_lg-o";
export var coverageDescription = "_lg-24";
export var coverageTitle = "_lg-23";
export var eyebrow = "_lg-i";
export var fieldCard = "_lg-m";
export var fieldDescription = "_lg-r";
export var fieldError = "_lg-s";
export var fieldHeader = "_lg-p";
export var fieldTitle = "_lg-q";
export var finalNote = "_lg-29";
export var footer = "_lg-a";
export var fulfillmentBody = "_lg-1u";
export var fulfillmentBodyText = "_lg-1v";
export var fulfillmentRow = "_lg-1r";
export var fulfillmentRows = "_lg-1q";
export var fulfillmentTitle = "_lg-1t";
export var header = "_lg-4";
export var heading = "_lg-h";
export var helperText = "_lg-1k";
export var indented = "_lg-1x";
export var inlineLink = "_lg-26";
export var inlineTitle = "_lg-2a";
export var intro = "_lg-k";
export var linkPreview = "_lg-1z";
export var listItem = "_lg-1d";
export var main = "_lg-1";
export var marketingImage = "_lg-c";
export var marketingPanel = "_lg-b";
export var modal = "_lg-0";
export var noteBody = "_lg-v";
export var noteBodyText = "_lg-w";
export var noteCard = "_lg-n";
export var noteIcon = "_lg-t";
export var noteTitle = "_lg-u";
export var numberBadge = "_lg-2e";
export var numberedStep = "_lg-2c";
export var numberedStepBody = "_lg-2f";
export var numberedStepCta = "_lg-2d";
export var numberedStepDescription = "_lg-2h";
export var numberedStepTitle = "_lg-2g";
export var numberedSteps = "_lg-2b";
export var page = "_lg-e";
export var playCircle = "_lg-18";
export var playIcon = "_lg-19";
export var policyBody = "_lg-21";
export var policyHeader = "_lg-20";
export var policyPreview = "_lg-1y";
export var policyTitle = "_lg-22";
export var progressFill = "_lg-8";
export var progressTrack = "_lg-7";
export var pseudoLink = "_lg-25";
export var pseudoLinkIcon = "_lg-27";
export var rowHeader = "_lg-1s";
export var section = "_lg-g";
export var shell = "_lg-2";
export var statusIconSuccess = "_lg-1m";
export var statusIconSvg = "_lg-1o";
export var statusIconWarning = "_lg-1n";
export var statusRow = "_lg-1l";
export var statusText = "_lg-1p";
export var stepTitle = "_lg-j";
export var strongText = "_lg-1w";
export var subHeading = "_lg-l";
export var videoEmbed = "_lg-16";
export var videoIframe = "_lg-17";
export var videoLabel = "_lg-1a";
export var videoPlaceholder = "_lg-15";
export var warningIcon = "_lg-1j";